import { AxiosInstance } from 'axios';

import { AuthTokenAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const AccessKeysApiFactory = (axiosClient: AxiosInstance) => {
  const client = AuthTokenAPIApiFactory(AXIOS_CONFIGURATION, '', axiosClient);

  return {
    deleteApiAccessKey: client.authTokenAPIDeleteAuthToken,
    updateApiAccessKey: client.authTokenAPIUpdateAuthToken,
    createApiAccessKey: client.authTokenAPICreateAuthToken,
    getApiAccessKeys: client.authTokenAPIListAuthTokens,
  };
};
